module.exports = __webpack_public_path__ + "static/media/gallery_01_thumb.472b096b.jpg";